import tinycolor from 'tinycolor2';
import { range, flatten, fill } from 'lodash';

export const solidColor = {
  variations: [
    {
      name: 'white',
      colors: [{ background: '#fff', textColor: '#333' }],
      strokeColor: '#666',
      strokeWidth: 1,
    }, {
      name: 'concrete',
      colors: [{ background: '#f1f1f1', textColor: '#333' }],
      strokeColor: '#666',
      strokeWidth: 1,
    }, {
      name: 'blackboard',
      colors: [{ background: '#333', textColor: '#fff' }],
      strokeColor: '#fff',
      strokeWidth: 1,
    }, {
      name: 'white-transparent',
      colors: [{ background: 'transparent', textColor: '#fff' }],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'black-transparent',
      colors: [{ background: 'transparent', textColor: '#333' }],
      strokeColor: '#333',
      strokeWidth: 2,
    }
  ],
  getColors: ({ colors }) => {
    return [colors];
  },
}

export const doubleDarkChroma = {
  variations: [
    {
      name: 'dusky-iris',
      colors: [ // Royal Snitch
        { background: '#453B5B', textColor: '#fff' },
        { background: '#F1BD42', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 0,
    }, {
      name: 'evening-patriot',
      colors: [ // Nautical
        { background: '#2C3E50', textColor: '#fff' },
        { background: '#FC4349', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 0,
    }, {
      name: 'majestic-tiger',
      colors: [
        { background: '#332F28', textColor: '#fff' },
        { background: '#C44E18', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 0,
    }, {
      name: 'sea-charcoal',
      colors: [
        { background: '#332F28', textColor: '#fff' },
        { background: '#61B594', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 0,
    }, {
      name: 'mermaid',
      colors: [
        { background: '#1BBC9B', textColor: '#fff' },
        { background: '#E64C66', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 0,
    }, {
      name: 'mother-earth',
      colors: [
        { background: '#0C273D', textColor: '#fff' },
        { background: '#70B85D', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 0,
    },
  ],
  getColors: ({ colors, strokeColor, amount }) => {
    const greys = [
      { background: '#BCB8B9', textColor: '#fff' },
      { background: '#999093', textColor: '#fff' },
    ];
    const colors1 = [
      colors[0],
      { background: tinycolor(colors[0].background).lighten(8).toString(), textColor: colors[0].textColor },
    ];
    const colors2 = [
      colors[1],
      { background: tinycolor(colors[1].background).lighten(8).toString(), textColor: colors[1].textColor },
    ];
    const center = [{ background: tinycolor(greys[0].background).lighten(5).toString(), textColor: greys[0].textColor }];
    return [center, greys, colors1, greys, colors2, greys, colors1, greys, colors2, greys];
  },
}


export const creamyRings = {
  variations: [
    {
      name: 'goldenrod-steel',
      colors: [
        { background: '#ECC833', textColor: '#554F43' },
        { background: '#7A776A', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'ripe-plum',
      colors: [ // Royal Snitch
        { background: '#453B5B', textColor: '#fff' },
        { background: '#F1BD42', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'morning-patriot',
      colors: [ // Nautical
        { background: '#2C3E50', textColor: '#fff' },
        { background: '#FC4349', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'beach-day',
      colors: [
        { background: '#F3CC54', textColor: '#554F43' },
        { background: '#92C4D3', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'golden-sunset',
      colors: [
        { background: '#F97F72', textColor: '#333' },
        { background: '#F3CC54', textColor: '#554F43' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'luck-o-the-irish',
      colors: [
        { background: '#17A780', textColor: '#333' },
        { background: '#FFAE00', textColor: '#554F43' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'goldenrod',
      colors: [
        { background: '#ECC833', textColor: '#554F43' },
        { background: '#D1CFC8', textColor: '#554F43' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'teaparty',
      colors: [
        { background: '#FB795D', textColor: '#333' },
        { background: '#FFC2B6', textColor: '#554F43' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'spring-eggplant',
      colors: [
        { background: '#422335', textColor: '#fff' },
        { background: '#A6E3A8', textColor: '#554F43' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'heirloom-tomato',
      colors: [
        { background: '#00A388', textColor: '#fff' },
        { background: '#FF6138', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'violet-clementine',
      colors: [
        { background: '#332532', textColor: '#fff' },
        { background: '#FF974F', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'turquoise-ebony',
      colors: [
        { background: '#2F2933', textColor: '#fff' },
        { background: '#01A2A6', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 2,
    }
  ],
  getColors: ({ colors, strokeColor, amount }) => {
    const creme = [
      { background: '#F6EFE2', textColor: '#554F43' }
    ]
    const colors1 = [
      colors[0],
      { background: tinycolor(colors[0].background).lighten(8).toString(), textColor: colors[0].textColor },
    ];
    const colors2 = [
      colors[1],
      { background: tinycolor(colors[1].background).lighten(8).toString(), textColor: colors[1].textColor },
    ];
    // const center = [{background: tinycolor(creme[0].background).lighten(5).toString(), textColor: creme[0].textColor}];
    return [colors1, creme, colors1, creme, colors2, creme, colors1, creme, colors2, creme];
  },
}


export const colorRings = {
  variations: [
    {
      name: 'aquamarine',
      colors: [
        { background: '#23B495', textColor: '#fff' }, // Sea Foam
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }, {
      name: 'amathest',
      colors: [
        { background: '#453B5B', textColor: '#fff' }, // Purple
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }, {
      name: 'rose-quartz',
      colors: [
        { background: '#f56944', textColor: '#fff' }, // Peach
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }, {
      name: 'dark',
      colors: [
        { background: '#333', textColor: '#fff' }, // dark grey
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    },
  ],
  getColors: ({ colors }) => {
    const color = colors[0];
    const lGrey = [{ background: '#BCB8B9', textColor: '#fff' }];
    const dGrey = [{ background: '#999093', textColor: '#fff' }];
    const lightColor = [{
      background: tinycolor(color.background).lighten(15).desaturate(10).toString(),
      textColor: colors[0].textColor,
    }];
    return [lightColor, dGrey, lightColor, lGrey, dGrey, lightColor, lGrey, dGrey, lightColor, lightColor];
  },
}


export const frosted = {
  variations: [
    {
      name: 'frosted-diamond',
      colors: [{ background: '#EDECEA', textColor: '#857B71' }],
      strokeColor: '#857B71',
      strokeWidth: 1,
    }, {
      name: 'frosted-rose',
      colors: [{ background: '#FBE1CC', textColor: '#857B71' }],
      strokeColor: '#857B71',
      strokeWidth: 1,
    }, {
      name: 'frosted-aquamarine',
      colors: [{ background: '#C1DBDB', textColor: '#605A53' }],
      strokeColor: '#605A53',
      strokeWidth: 1,
    }, {
      name: 'frosted-opal',
      colors: [{ background: '#CBD7E5', textColor: '#857B71' }],
      strokeColor: '#857B71',
      strokeWidth: 1,
    },
  ],
  getColors: ({ colors }) => {
    const color = colors[0];
    const whites = [
      { background: '#FFFAF5', textColor: '#857B71' },
      { background: '#FFFDFA', textColor: '#857B71' },
    ]

    const _colors = [
      color,
      { background: tinycolor(color.background).lighten(8).toString(), textColor: color.textColor },
    ];

    const center = [{ background: whites[0].background, textColor: whites[0].textColor }];

    return [center, whites, _colors, whites, _colors, whites, _colors, whites, _colors, whites];
  },
}

export const ombre = {
  variations: [
    {
      name: 'rose',
      colors: [{ background: '#E6787B', textColor: '#fff' }],
      amount: 3,
      strokeWidth: 2,
      strokeColor: '#fff',
    }, {
      name: 'seafoam',
      colors: [{ background: '#1BBC9B', textColor: '#fff' }],
      amount: 6,
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'mauve',
      colors: [{ background: '#953D65', textColor: '#fff' }],
      amount: 5,
      strokeColor: '#fff',
      strokeWidth: 2,
    }, {
      name: 'greyscale',
      colors: [{ background: '#222', textColor: '#fff' }],
      amount: 5,
      strokeColor: '#fff',
      strokeWidth: 2,
    }
  ],
  getColors: ({ colors, strokeColor, amount }) => {
    const { background, textColor } = colors[0];
    return range(0, 10).map(i => [{
      background: tinycolor(background).lighten(i * amount).toString(),
      bandColor: tinycolor(background).lighten((i - 1) * amount).toString(),
      textColor,
      strokeColor,
    }])
  },
}

export const bananaSundaes = {
  variations: [
    {
      name: 'mocha-chip',
      colors: [
        { background: '#F5F1E9', textColor: '#635B4C' },
        { background: '#DED4C0', textColor: '#635B4C' },
        { background: '#635B4C', textColor: '#DED4C0' },
      ],
      strokeColor: '#fff',
      strokeWidth: 8,
    }, {
      name: 'chocolate-chip',
      colors: [
        { background: '#FFFBED', textColor: '#554E41' },
        { background: '#EEEADD', textColor: '#554E41' },
        { background: '#554E41', textColor: '#EEEADD' },
      ],
      strokeColor: '#fff',
      strokeWidth: 8,
    }, {
      name: 'chocolate-strawberry',
      colors: [
        { background: '#FFF8F2', textColor: '#695849' },
        { background: '#FFF8F2', textColor: '#695849' },
        { background: '#C3A68D', textColor: '#FFF8F2' },
      ],
      strokeColor: '#fff',
      strokeWidth: 8,
    }, {
      name: 'caramel-vanilla',
      colors: [
        { background: '#FAF5EF', textColor: '#8D8777' },
        { background: '#FAF5EF', textColor: '#8D8777' },
        { background: '#EDE3CB', textColor: '#8D8777' },
      ],
      strokeColor: '#fff',
      strokeWidth: 8,
    }
  ],
  getColors: ({ colors }) => {
    const light = colors[0];
    const medium = colors[1];
    const dark = colors[2];

    return [
      [light],
      [medium],
      [light],
      [medium, light],
      [medium, dark],
      [light],
      [medium, light],
      [light],
      [medium, dark],
      [light],
      [medium, light],
      [light],
    ];
  }
}


export const fiesta = {
  variations: [
    {
      name: 'raspberry-revelry',
      colors: [
        { background: '#F4634A', textColor: '#fff' },
        { background: '#345F5F', textColor: '#fff' },
        { background: '#9B1649', textColor: '#fff' },
        { background: '#DBCE4A', textColor: '#fff' },
        { background: '#D2D4E1', textColor: '#fff' },
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }, {
      name: 'merry-melon',
      colors: [
        { background: '#F4634A', textColor: '#fff' },
        { background: '#DFDFB7', textColor: '#fff' },
        { background: '#9B1649', textColor: '#fff' },
        { background: '#F4634A', textColor: '#fff' },
        { background: '#F8FAF0', textColor: '#F4634A' },
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }, {
      name: 'whirligig-watermelon',
      colors: [
        { background: '#F4634A', textColor: '#fff' },
        { background: '#1A4943', textColor: '#fff' },
        { background: '#F6E7DD', textColor: '#1A4943' },
        { background: '#F6E7DD', textColor: '#1A4943' },
        { background: '#6E9219', textColor: '#DFDFB7' },
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }, {
      name: 'grape-gala',
      colors: [
        { background: '#F4634A', textColor: '#fff' },
        { background: '#E0DCE0', textColor: '#fff' },
        { background: '#E6CBD4', textColor: '#fff' },
        { background: '#E6CBD4', textColor: '#fff' },
        { background: '#6C2158', textColor: '#DFDFB7' },
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }
  ],
  getColors: ({ colors }) => {
    const center = { background: '#fff', textColor: colors[0].background };
    return [
      [center],
      [colors[0]],
      [colors[1]],
      [colors[2], colors[3]],
      [colors[4], colors[0]],

      [colors[0]],
      [colors[1]],
      [colors[2], colors[3]],
      [colors[4], colors[0]],
      [colors[0]],
      [colors[1]],
    ];
  }
}

const bandedFade = ({ colors, darken }, generations) => {
  const color = colors[0].background;
  return range(0, 10).map(i => [{
    background: '#fff',
    textColor: i === 0 ? tinycolor(color).darken(darken * (generations - 2)).toString() : '#222',
    bandColor: i < generations - 1 ? tinycolor(color).darken(darken * i).toString() : 'transparent',
  }])
}
export const banded = {
  variations: [
    {
      name: 'gold',
      strokeColor: '#222',
      strokeWidth: 0,
      darken: 7,
      fn: bandedFade,
      colors: [{ background: '#f0e5c6' }]
    }, {
      name: 'jade',
      strokeColor: '#222',
      strokeWidth: 0,
      darken: 7,
      fn: bandedFade,
      colors: [{ background: '#C1F1CB' }]
    }, {
      name: 'rainbow',
      colors: [
        { background: '#aae5cf' },
        { background: '#dcecc3' },
        { background: '#fed3b8' },
        { background: '#fdaaa7' },
        { background: '#fd8c96' },
      ],
      fn: ({ colors }) => range(0, 10).map(i => [{
        background: '#f9f9f9',
        textColor: '#222',
        bandColor: colors[i % colors.length].background
      }]),
      strokeColor: '#fff',
      strokeWidth: 8,
    }
  ],
  getColors: (v, generations) => v.fn(v, generations)
}

export const naturalLight = {
  variations: [
    {
      name: 'natural-leaf',
      colors: [
        { background: '#FFFDFC', textColor: '#6D6F63' },
        { background: '#F8FAF0', textColor: '#6D6F63' },
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }, {
      name: 'natural-petal',
      colors: [
        { background: '#FFFCFA', textColor: '#9E8A86' },
        { background: '#FFF4F2', textColor: '#9E8A86' },
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }, {
      name: 'natural-stem',
      colors: [
        { background: '#FFFCFA', textColor: '#897E78' },
        { background: '#F6F1EE', textColor: '#897E78' },
      ],
      strokeColor: '#fff',
      strokeWidth: 5,
    }
  ],
  getColors: ({ colors }) => {
    const light = colors[0];
    const dark = colors[1];
    return [
      [light],
      [light],
      [dark],
      [light],
      [dark, light],
      [light],
      [dark, light],
      [light],
      [dark, light],
      [dark],
    ]
  }
}


// export const cascadingHues = {
//   variations: [
//     {
//       name: 'natural-leaf',
//       colors: [
//         {background: '#f50', textColor: '#fff'},
//       ],
//       strokeColor: '#fff',
//       strokeWidth: 0,
//     },{
//       name: 'natural-leaf',
//       colors: [
//         {background: '#ab71b5', textColor: '#fff'},
//       ],
//       strokeColor: '#fff',
//       strokeWidth: 0,
//     }
//   ],
//   getColors: ({colors}) => {
//     const color = colors[0];
//     const _colors =  range(0, 10).map(g => {
//       const n = Math.pow(2, g);
//       const amount = 50 / n;
//       return range(0, n).map(i => ({
//         background: tinycolor(color.background).spin(i * amount).toString(),
//         textColor: color.textColor,
//       }))
//     })
//     _colors[0][0].background = 'transparent';
//     return _colors;
//   }
// }


export const thematic = {
  variations: [
    {
      name: 'family-search',
      colors: [
        { background: '#d9f4fb', textColor: '#000', bandColor: '#29c5ea' },
        { background: '#ebf9e5', textColor: '#000', bandColor: '#99cb7c' },
        { background: '#fee4e2', textColor: '#000', bandColor: '#f5736e' },
        { background: '#fdfee8', textColor: '#000', bandColor: '#fbf492' },
      ],
      getColors: colors => {
        const _colors = range(2, 10).map(g => {
          const n = Math.pow(2, g);
          const q = n / 4;
          return range(0, n).map(i => colors[Math.floor(i / q)]);
        })

        const firstG = [{ background: '#fff', textColor: '#000' }];
        const secondG = [
          {
            background: [colors[0].background, colors[1].background],
            textColor: '#000',
            bandColor: [colors[0].bandColor, colors[1].bandColor]
          },
          {
            background: [colors[2].background, colors[3].background],
            textColor: '#000',
            bandColor: [colors[2].bandColor, colors[3].bandColor]
          },
        ]
        return [firstG, secondG, ..._colors];
      },
      strokeColor: '#ddd',
      strokeWidth: 6,
    },
    {
      name: 'tree-roots',
      colors: [
        { background: '#ffffff', textColor: '#11150F' },
        { background: '#8bc34a', textColor: '#11150F' },
      ],
      getColors: colors => {
        const { background, textColor } = colors[1];
        const treeRings = range(0, 9).map(i => [{
          background: tinycolor(background).lighten(i * 5).toString(),
          bandColor: tinycolor(background).lighten((i + 2) * 5).toString(),
          textColor,
        }])
        return [[colors[0]], ...treeRings];
      },
      strokeWidth: 6,
      strokeColor: '#B0D683',
    },
    {
      name: 'bb8',
      colors: [
        { background: '#BEBEBE', textColor: '#fff' },
        { background: '#fff', textColor: '#BEBEBE' },
        { background: '#EEEEEE', textColor: '#BEBEBE' },
        { background: '#FFB53C', textColor: '#fff' },
      ],
      getColors: colors => [
        [colors[0], colors[1]],
        [colors[2]],
        [colors[1], colors[0]],
        [colors[3]],
        [colors[2]],
      ],
      strokeColor: '#fff',
      strokeWidth: 10,
    }, {
      name: 'millenium-falcon',
      colors: [
        { background: '#BEBEBE', textColor: '#fff' },
        { background: '#fff', textColor: '#BEBEBE' },
        { background: '#DFDFDF', textColor: '#BEBEBE' },
      ],
      getColors: colors => [
        [colors[0]],
        [colors[2]],
        [colors[1]],
      ],
      strokeColor: '#fff',
      strokeWidth: 6,
    }, {
      name: 'captain-america',
      colors: [
        { background: 'rgba(255,255,255,0.0)', textColor: '#193070' },
        { background: '#F6FFEA', textColor: '#193070' },
        { background: '#EF5534', textColor: '#F6FFEA' },
      ],
      getColors: colors => [
        [colors[0]],
        [colors[1]],
        [colors[2]],
        [colors[1]],
        [colors[2]],
        [colors[1]],
        [colors[2]],
        [colors[1]],
        [colors[2]],
        [colors[1]],
      ],
      strokeColor: '#F6FFEA',
      strokeWidth: 10,
    }, {
      name: 'uss-enterprise',
      colors: [
        { background: '#BEBEBE', textColor: '#fff' },
        { background: '#fff', textColor: '#575757' },
        { background: '#F2F2F2', textColor: '#575757' },
      ],
      getColors: colors => [
        [colors[0]],
        [colors[2]],
        [colors[1]],
        [colors[0]],
        [colors[2]],
      ],
      strokeColor: '#575757',
      strokeWidth: 6,
    }, {
      name: 'minimalist-turtle',
      colors: [{ background: '#7DB937', textColor: '#fff' }],
      getColors: colors => [
        [colors[0]],
      ],
      strokeWidth: 6,
      strokeColor: '#629B27',
    }, {
      name: 'minimalist-toucan',
      colors: [
        { background: '#202020', textColor: '#fff' },
        { background: '#F89F1C', textColor: '#fff' },
        { background: '#FF6900', textColor: '#fff' },
        { background: '#00D084', textColor: '#fff' },
      ],
      getColors: colors => {
        const _colors = range(0, 10).map(g => {
          const n = Math.pow(2, g);
          const halfN = n / 2;
          return range(0, n).map(i => i < halfN ? colors[0] : colors[1])
        });

        _colors[2][2] = colors[2];
        _colors[3][4] = colors[3];
        _colors[3][5] = colors[3];
        return _colors;
      },
      strokeWidth: 3,
      strokeColor: '#202020',
    }, {
      name: 'minimalist-whale',
      colors: [
        { background: '#78BDF5', textColor: '#fff' },
      ],
      getColors: colors => [colors],
      strokeWidth: 1,
      strokeColor: '#5694C7',
    }, {
      name: 'minimalist-lady-bug',
      colors: [
        { background: '#E44D4D', textColor: '#fff' },
      ],
      getColors: colors => [colors],
      strokeWidth: 5,
      strokeColor: '#fff',
    }, {
      name: 'minimalist-crab',
      colors: [
        { background: '#E44D4D', textColor: '#fff' },
      ],
      getColors: colors => [colors],
      strokeWidth: 4,
      strokeColor: '#fff',
    }, {
      name: 'minimalist-fox',
      colors: [
        { background: '#FB6F19', textColor: '#fff' },
        { background: '#fff', textColor: '#202020' },
        { background: '#202020', textColor: '#fff' },
        { background: '#E4DAD2', textColor: '#202020' },
      ],
      getColors: colors => {
        const _colors = range(0, 10).map(g => {
          const n = Math.pow(2, g);
          return range(0, n).map(i => g < 3 ? colors[1] : colors[0])
        });

        _colors[3][1] = colors[2];
        _colors[3][2] = colors[2];
        _colors[2][0] = colors[0];
        _colors[2][1] = colors[0];
        _colors[1][0] = colors[2];
        _colors[1][1] = colors[3];
        return _colors;
      },
      strokeWidth: 10,
      strokeColor: '#202020',
    }, {
      name: 'minimalist-pig',
      colors: [
        { background: '#FFC3D8', textColor: '#704150' },
        { background: '#fff', textColor: '#704150' },
        { background: '#D794AB', textColor: '#fff' },
      ],
      getColors: colors => {
        const _colors = range(0, 10).map(g => {
          const n = Math.pow(2, g);
          return range(0, n).map(i => g < 3 ? colors[1] : colors[0])
        });
        _colors[1][0] = colors[2];
        return _colors;
      },
      strokeWidth: 2,
      strokeColor: '#D794AB',
    }, {
      name: 'safari-giraffe',
      colors: [
        { background: '#FFC313', textColor: '#fff' },
      ],
      getColors: colors => [colors],
      strokeWidth: 5,
      strokeColor: '#fff',
    }, {
      name: 'safari-hippo',
      colors: [
        { background: '#D7AFFA', textColor: '#fff' },
      ],
      getColors: colors => [colors],
      strokeWidth: 1,
      strokeColor: '#fff',
    }, {
      name: 'pig',
      colors: [
        { background: '#FFC3BA', textColor: '#4A251F' },
        { background: '#F8A396', textColor: '#4A251F' },
      ],
      getColors: colors => range(10).map(i => i < 2 ? [colors[0]] : [colors[1]]),
      strokeWidth: 0,
      strokeColor: '#fff',
    }, {
      name: 'peacock',
      colors: [
        { background: '#032157', textColor: '#fff' },
        { background: '#1CADAA', textColor: '#fff' },
        { background: '#0A5858', textColor: '#fff' },
        { background: '#DBCE4B', textColor: '#fff' },
      ],
      getColors: colors => [
        [colors[0]],
        [colors[1]],
        [colors[0], colors[2]],
        [colors[1], colors[3]],
        [colors[0], colors[2]],
        [colors[1], colors[3]],
        [colors[0], colors[2]],
        [colors[1], colors[3]],
        [colors[0], colors[2]],
        [colors[1], colors[3]],
      ],
      strokeWidth: 6,
      strokeColor: '#fff',
    }, {
      name: 'watermelon',
      colors: [
        { background: '#FD8699', textColor: '#333' },
        { background: '#FAFFE0', textColor: '#333', bandColor: '#546600' },
        { background: '#F2FACD', textColor: '#333', bandColor: '#546600' },
      ],
      getColors: (colors, generations) => {
        return range(0, 10).map(i => i < generations - 1 ? [colors[0]] : [colors[1], colors[2]])
      },
      strokeWidth: 0,
      strokeColor: '#fff',
    }, {
      name: 'dog',
      colors: [
        { background: '#955531', textColor: '#2C3A3D' },
        { background: '#2C3A3D', textColor: '#fff' },
        { background: '#BC7C40', textColor: '#2C3A3D' },
      ],
      getColors: colors => [
        [colors[0]],
        [colors[1]],
        ...fill(Array(8), [colors[2]]),
      ],
      strokeWidth: 0,
      strokeColor: '#fff',
    }, {
      name: 'unicorn',
      colors: [
        { background: '#FFD9D9', textColor: '#333' },
        { background: '#FFE9E9', textColor: '#333' },
      ],
      getColors: colors => [
        [colors[0]],
        ...fill(Array(9), [colors[1]]),
      ],
      strokeWidth: 0,
      strokeColor: '#fff',
    }, {
      name: 'viking-ship',
      colors: [
        { background: '#635C4C', textColor: '#fff' },
        { background: '#DFD4C0', textColor: '#333' },
      ],
      getColors: colors => [
        [colors[0], colors[1]],
        [colors[1]],
        [colors[0]],
      ],
      strokeWidth: 6,
      strokeColor: '#fff',
    }, {
      name: 'dinosaur',
      colors: [
        { background: '#788D30', textColor: '#fff' },
        { background: '#818C54', textColor: '#fff' },
        { background: '#515942', textColor: '#fff' },
        { background: '#1A2602', textColor: '#fff' },
      ],
      getColors: colors => [
        [colors[0], colors[1]],
        [colors[2], colors[3]],
      ],
      strokeWidth: 6,
      strokeColor: '#fff',
    }, {
      name: 'sunrise',
      colors: [
        { background: '#FFFA5C', textColor: '#732E18' },
        { background: '#FFEB5C', textColor: '#732E18' },
        { background: '#FFDE59', textColor: '#732E18' },
      ],
      getColors: colors => [
        [colors[0]],
        [colors[0]],
        [colors[1]],
        [colors[2]],
      ],
      strokeWidth: 0,
      strokeColor: '#fff',
    }, {
      name: 'rainbow',
      colors: [
        { background: '#fff', textColor: '#333' },
        { background: '#C277FC', textColor: '#fff' },
        { background: '#1B94E0', textColor: '#fff' },
        { background: '#96D652', textColor: '#fff' },
        { background: '#FCE678', textColor: '#fff' },
        { background: '#FCB82C', textColor: '#fff' },
        { background: '#FD686A', textColor: '#fff' },
        { background: '#C277FC', textColor: '#fff' },
        { background: '#1B94E0', textColor: '#fff' },
        { background: '#96D652', textColor: '#fff' },
      ],
      getColors: colors => colors.map(color => [color]),
      strokeWidth: 6,
      strokeColor: '#fff',
    }, {
      name: 'sunflower',
      colors: [
        { background: '#FFDE59', textColor: '#333' },
        { background: '#FFFA5C', textColor: '#333' },
      ],
      getColors: colors => [
        [colors[0]],
        ...fill(Array(9), [colors[1]]),
      ],
      strokeWidth: 0,
      strokeColor: '#fff',
    }, {
      name: 'panda',
      colors: [
        { background: '#333', textColor: '#fff' },
        { background: '#fff', textColor: '#333' },
      ],
      getColors: colors => [
        [colors[0]],
        [colors[1]],
        [colors[1], colors[0], colors[0], colors[1]],
        [colors[1]],
      ],
      strokeWidth: 1,
      strokeColor: '#333',
    }, {
      name: 'dia-de-los-muertos',
      colors: [
        { background: '#FEFBE8', textColor: '#381D46' },
        { background: '#FEF9DB', textColor: '#381D46' },
        { background: '#381D46', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#37429C', textColor: '#fff' },
        { background: '#381D46', textColor: '#fff' },
        { background: '#DBCE4B', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#9B1749', textColor: '#fff' },
        { background: 'transparent', textColor: '#fff' },
      ],
      getColors: diaDeLosMuertos,
      strokeWidth: 3,
      strokeColor: '#fff',
    }, {
      name: 'dia-de-los-muertos-fall',
      colors: [
        { background: '#FEFBE8', textColor: '#15133B' },
        { background: '#FEF9DB', textColor: '#15133B' },
        { background: '#15133B', textColor: '#fff' },
        { background: '#F64C34', textColor: '#fff' },
        { background: '#E19E3B', textColor: '#fff' },
        { background: '#15133B', textColor: '#fff' },
        { background: '#00779C', textColor: '#fff' },
        { background: '#FF7E67', textColor: '#fff' },
        { background: '#F64C34', textColor: '#fff' },
        { background: 'transparent', textColor: '#fff' },
      ],
      getColors: diaDeLosMuertos,
      strokeWidth: 3,
      strokeColor: '#fff',
    }, {
      name: 'dia-de-los-muertos-dark',
      colors: [
        { background: '#333333', textColor: '#fff' },
        { background: '#333333', textColor: '#fff' },
        { background: '#FEFBE8', textColor: '#333333' },
        { background: '#F44822', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#FFD1CB', textColor: '#9B173E' },
        { background: '#C93416', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#9B173E', textColor: '#fff' },
        { background: 'transparent', textColor: '#fff' },
      ],
      getColors: diaDeLosMuertos,
      strokeWidth: 3,
      strokeColor: '#fff',
    }, {
      name: 'dia-de-los-muertos-raspberry',
      colors: [
        { background: '#FEFBE8', textColor: '#381D46' },
        { background: '#FEF9DB', textColor: '#381D46' },
        { background: '#333333', textColor: '#FEFBE8' },
        { background: '#9B1749', textColor: '#fff' },
        { background: '#DBCE4B', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#D2D4E1', textColor: '#fff' },
        { background: '#335F5E', textColor: '#fff' },
        { background: '#9A1548', textColor: '#fff' },
        { background: 'transparent', textColor: '#fff' },
      ],
      getColors: diaDeLosMuertos,
      strokeWidth: 3,
      strokeColor: '#fff',
    }, {
      name: 'dia-de-los-muertos-skull',
      colors: [
        { background: '#FEFBE8', textColor: '#381D46' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#37429C', textColor: '#fff' },
        { background: '#381D46', textColor: '#fff' },
        { background: '#DBCE4B', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#9B1749', textColor: '#fff' },
      ],
      getColors: diaDeLosMuertosSkull,
      strokeWidth: 3,
      strokeColor: '#fff',
    }, {
      name: 'dia-de-los-muertos-skull-fall',
      colors: [
        { background: '#FEFBE8', textColor: '#15133B' },
        { background: '#F64C34', textColor: '#fff' },
        { background: '#E19E3B', textColor: '#fff' },
        { background: '#15133B', textColor: '#fff' },
        { background: '#00779C', textColor: '#fff' },
        { background: '#FF7E67', textColor: '#fff' },
        { background: '#F64C34', textColor: '#fff' },
      ],
      getColors: diaDeLosMuertosSkull,
      strokeWidth: 3,
      strokeColor: '#fff',
    }, {
      name: 'dia-de-los-muertos-skull-dark',
      colors: [
        { background: '#333333', textColor: '#fff' },
        { background: '#F44822', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#FFD1CB', textColor: '#9B173E' },
        { background: '#C93416', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#9B173E', textColor: '#fff' },
      ],
      getColors: diaDeLosMuertosSkull,
      strokeWidth: 3,
      strokeColor: '#fff',
    }, {
      name: 'dia-de-los-muertos-skull-raspberry',
      colors: [
        { background: '#FEFBE8', textColor: '#381D46' },
        { background: '#9B1749', textColor: '#fff' },
        { background: '#DBCE4B', textColor: '#fff' },
        { background: '#F5634A', textColor: '#fff' },
        { background: '#D2D4E1', textColor: '#fff' },
        { background: '#335F5E', textColor: '#fff' },
        { background: '#9A1548', textColor: '#fff' },
      ],
      getColors: diaDeLosMuertosSkull,
      strokeWidth: 3,
      strokeColor: '#fff',
    },

  ],
  getColors: ({ colors, getColors }, generations) => {
    return getColors(colors, generations);
  }
}


function diaDeLosMuertos(colors, generations) {
  if (generations >= 6) {
    return [
      [colors[9]],
      [colors[0]],
      [colors[2], colors[0], colors[0], colors[2]],
      [colors[0]],
      [colors[3], colors[4]],
      [colors[5], colors[6]],
      [colors[7], colors[8]],
      [colors[3], colors[4]],
      [colors[5], colors[6]],
      [colors[7], colors[8]],
    ]
  }
  return [
    [colors[9]],
    [colors[2], colors[2]],
    [colors[0]],
    [colors[3], colors[4]],
    [colors[5], colors[6]],
    [colors[7], colors[8]],
    [colors[3], colors[4]],
    [colors[5], colors[6]],
    [colors[7], colors[8]],
    [colors[3], colors[4]],
  ]
}

function diaDeLosMuertosSkull(colors) {
  return [
    [colors[0]],
    [colors[1], colors[2]],
    [colors[3], colors[4]],
    [colors[5], colors[6]],
    [colors[1], colors[2]],
    [colors[3], colors[4]],
    [colors[5], colors[6]],
    [colors[1], colors[2]],
    [colors[3], colors[4]],
    [colors[5], colors[6]],
  ];
}


// WEBPACK FOOTER //
// ./src/core/palettes/options.js